export const InitializeAnalytics = () => {
    if (window.gtmInitialized) return;

    try {
        // Dynamic GTM script tag injection
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!=='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-55SZ2MMH');

        // Dynamic GTM noscript iframe injection for complete GTM support
        const noscript = document.createElement('noscript');
        const iframe = document.createElement('iframe');
        iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-55SZ2MMH';
        iframe.height = '0';
        iframe.width = '0';
        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';
        noscript.appendChild(iframe);
        document.body.appendChild(noscript);

        window.gtmInitialized = true;
        //console.log('[Analytics] Google Tag Manager & GA4 dynamically initialized.');
    } catch (e) {
        //console.error('[Analytics] Error initializing GTM script:', e);
    }
};
